export enum Strategies {
	Manual = 'MANUAL',
	Smart = 'SMART',
}
